module.exports = __webpack_public_path__ + "img/read_trend_bg.0563852a.png";